import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { installStaleBuildRecovery } from '@/lib/staleBuild';
import '@/styles/globals.css';

// Before rendering: lazy routes may load right away.
installStaleBuildRecovery();

const container = document.getElementById('root');

if (!container) {
	throw new Error('Root element #root was not found in index.html');
}

createRoot(container).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
